import { EnumValue, Enum } from '@/core/utils/enum';
import { RequestState } from '@/api/core';
import { HydrationHelper } from '@/store/plugins/hydration';

export default function registerCommonTypes() {
  HydrationHelper.registerType(EnumValue);
  HydrationHelper.registerType(Enum);
  HydrationHelper.registerType(RequestState);
}
